import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-services-accordion',
  templateUrl: './main-services-accordion.component.html',
  styleUrls: ['./main-services-accordion.component.css']
})
export class MainServicesAccordionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
